// extracted by css-extract-rspack-plugin
export default {"root":"PageStub_root__i9Cid"};